import Grid from "@mui/material/Grid";
import styled from "@mui/system/styled";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { DocumentReferenceResponse } from "api/generatedApi";
import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";
import { formatTimestamp } from "utils/formats";
import { useDownloadDocument } from "./hooks/use-download-document";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Box, IconButton } from "@mui/material";

interface DocumentRowProps {
  allowDownload: boolean;
  document: DocumentReferenceResponse;
  canDeleteDocument: () => boolean;
  clickDocumentDelete?: (document: DocumentReferenceResponse) => void;
  inADialog?: boolean;
  textColor?: string;
  allowDownloadWhileInDialog?: boolean;
}

export function DocumentRow(props: DocumentRowProps) {
  const { document, allowDownload, canDeleteDocument, inADialog, clickDocumentDelete } = props;
  const downloadFolderDocument = useDownloadDocument();
  const { screenSize } = useScreenSize();

  const downloadClicked = (event: React.MouseEvent<HTMLElement>, doc: DocumentReferenceResponse) => {
    event.stopPropagation();
    if (allowDownload) {
      downloadFolderDocument(doc);
    }
  };

  const deleteClicked = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!document?.documentId) {
      return;
    }
    event.stopPropagation();
    clickDocumentDelete?.(document);
  };

  const DocumentRowGridStyled = styled(Grid)`
    height: 28px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  `;

  const DocumentNameGridItemStyled = styled(Grid)`
    display: flex;
    padding-left: 5px;
  `;
  return (
    <DocumentRowGridStyled container key={document?.documentId} onClick={(e) => (!inADialog || props.allowDownloadWhileInDialog ? downloadClicked(e, document) : undefined)}>
      <DocumentNameGridItemStyled item xs={10} sm={7} md={7} lg={7} xl={7}>
        <PictureAsPdfOutlinedIcon fontSize="small" sx={{ mr: "3px", color: props.textColor || "primary.main" }} />
        <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textAlign: "left", color: props.textColor || "primary.main" }}>{document?.name}</Box>
      </DocumentNameGridItemStyled>

      {screenSize === ScreenSizeEnum.Desktop && (
        <Grid item xs={3} sx={{ textAlign: "end", color: props.textColor || "primary.main" }}>
          {formatTimestamp(document?.uploadedTimestamp).slice(0, -5)}
        </Grid>
      )}
      {screenSize === ScreenSizeEnum.LargeDesktop && (
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4} sx={{ textAlign: "right", color: props.textColor || "primary.main" }}>
          {formatTimestamp(document?.uploadedTimestamp).slice(0, -5)}
        </Grid>
      )}

      {canDeleteDocument() && inADialog && (
        <Grid item xs={1} sx={{ textAlign: "right" }}>
          <IconButton sx={{ padding: "0px" }} onClick={(e) => deleteClicked(e)}>
            <DeleteOutlinedIcon fontSize="small" />
          </IconButton>
        </Grid>
      )}
    </DocumentRowGridStyled>
  );
}
